import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { teacherVoices, moreTeacherVoices } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-sand font-sans text-night selection:bg-coral selection:text-night" data-id="element-0" data-mp="3mlj98vzqhf3l">
      <MetaPixel data-id="element-1" data-mp="3rcj2nr9n9f1c" />
      <main data-id="element-2" data-mp="3rbzpsoyupgu6">
        <Hero data-id="element-3" data-mp="3rdkgg3i1ofmr" />
        <SocialProofBar data-id="element-4" data-mp="3rd1azm9kzjpm" />
        <PainGrid data-id="element-5" data-mp="3relwynhtxubv" />
        <ProductReveal data-id="element-6" data-mp="5opww5kum4f" />
        <LookInside data-id="element-7" data-mp="4wx1t3d72hu" />
        <Tomes data-id="element-8" data-mp="5gbv0xpxarn" />
        <Bonuses data-id="element-9" data-mp="82jf0klzq9v" />
        <ValueStack data-id="element-10" data-mp="2zl3c5m4yv85u" />
        <Urgency data-id="element-11" data-mp="2zllijblcf2rh" />
        <Pricing data-id="element-12" data-mp="2zm4vedw4z0yn" />
        <Reviews data-id="element-13" data-mp="2zmo89g6xiz5t" />
        <Testimonials voices={teacherVoices} background="white" data-id="element-14" data-mp="2zn678kkz7rhf" />
        <Guarantee data-id="element-15" data-mp="33ngfk3w8qtzg" />
        <Faq data-id="element-16" data-mp="33myix65o2dr0" />
        <Testimonials voices={moreTeacherVoices} title="Every acro teacher hits the same wall" background="panel" data-id="element-17" data-mp="33oi1j3esp0vy" />
        <CostOfInaction data-id="element-18" data-mp="3dlw9sfqkejd6" />
        <Close data-id="element-19" data-mp="3dm5ze27p6oic" />
      </main>
      <Footer data-id="element-20" data-mp="nvj3jfxq0epq" />
      <PurchaseNotifications data-id="element-21" data-mp="nw2ak1lu1ioz" />
    </div>;
}